import { Injectable } from '@angular/core';
import { SessionService } from '../../shared/session-service/session.service';
import { RightSideDrawerService } from '../../shared/right-side-drawer/right-side-drawer.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { ToastrService } from '@kpmg-tax/ui';
import { Project } from '../../shared/models/project.model';
import { API_URL } from 'src/app/shared/constants/apiurl-constants';
import { BaseResponse } from 'src/app/shared/models/base-response.model';
import { Messages } from '../../shared/constants/messages';

@Injectable({ providedIn: 'root' })
export class DefineProjectsService {
  engagementID: number;
  initialCount: number;
  projectsTableRefresh = new BehaviorSubject({});
  addDrawer = new BehaviorSubject({});
  enableAddDrawer = this.addDrawer.asObservable();
  refreshProjects = this.projectsTableRefresh.asObservable();
  private projectsSource = new BehaviorSubject<Project[]>(null);
  projectsObservable = this.projectsSource.asObservable();

  constructor(public sessionService: SessionService, public toastrService: ToastrService, public rightSideDrawerService: RightSideDrawerService) { }

  private _tableDataFiltered: Project[] = [];

  get eiPrjTableDataFiltered(): Project[] {
    return this._tableDataFiltered;
  }
  set eiPrjTableDataFiltered(value: Project[]) {
    this._tableDataFiltered = value;
  }

  showAddDrawer() {
    this.addDrawer.next(true);
  }

  refreshTable() {
    this.projectsTableRefresh.next(true);
  }

  deleteRowProject = (row: Project) => {
    let projectId = row.projectId;
    let projectData = {
      projectId: projectId,
      engagementId: Number(this.sessionService.getSession('engagementId')),
    };
    this.sessionService.apiUrlPost(API_URL.DELETEPROJECT, projectData).subscribe(
      (data: BaseResponse) => {
        if (data !== null && data.success) {
          if (data.result) {
            this.refreshTable();
            let tabledata: any = this.eiPrjTableDataFiltered.filter(
              item => item.projectId !== projectId,
            );
            this.eiPrjTableDataFiltered = [...tabledata];
            this.toastrService.setSuccessMessage(
              Messages.Project.DeleteProjectSuccess,
            );
          } else {
            this.toastrService.setErrorMessage(
              Messages.Project.ProjectAssignedToDocument,
            );
          }
        } else if (
          data !== null &&
          !data.success &&
          data.errorMessage === 'ASSIGNED'
        ) {
          this.toastrService.setErrorMessage(
            Messages.Project.ProjectAssignedToSurvey,
          );
        } else {
          this.toastrService.setErrorMessage(
            Messages.Project.DeleteProjectFailure,
          );
        }
      });
  }

  getProjects(engagementId: string) {
    return this.sessionService.apiUrlGet(API_URL.GETPROJECTS + '?engagementId=' + engagementId);
  }

  getProjectNames(engagementId: number, surveyType = 0){
    return this.sessionService.apiUrlGet(API_URL.GETPROJECTNAMES + '?engagementId=' + engagementId+ '&surveyType=' + surveyType);
  }

  getProjectsByStudy(studyId: number): void {
    this.sessionService.apiUrlGet(API_URL.GETPROJECTS + '?engagementId=' + studyId.toString()).subscribe(response => {
      if (response) {
        let projects = response as Project[];
        this.projectsSource.next(projects);
      }
    })
  }


  bulkUpdateProjects(data: any) {
    return this.sessionService.apiUrlPost(API_URL.TIMETRACKING.BULKEDITPROJECT, data);
  }


  public getImportFileStatus(engagementId) {
    return this.sessionService.apiUrlGet(
      API_URL.GET_IMPORT_FILE_STATUS + '?engagementId=' + engagementId,
    );
    }

    getEntityList(engagementId): Observable<any> {
      return this.sessionService.apiUrlGet(API_URL.LEGAL_ENTITY.GET_ENTITIES + '?engagementId=' + engagementId) as Observable<any>;
  }
}
